import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className={`${appData.icon} text-2xl text-background-50`}></i>
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {appData.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-2">{appData.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
            {appData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="#updates" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-apple-line"></i>
              iOS 版
            </a>
            <a href="#updates" className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-background-50 font-medium text-sm rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-android-line"></i>
              Android 版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}